const map = {
	"./backtotop.svg": 12972,
	"./facebook.svg": 781,
	"./instagram.svg": 95943,
	"./pinterest.svg": 53629,
	"./twitter.svg": 23146,
	"./unicity.svg": 82200,
	"./youtube.svg": 30032
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53013;